/**
 * @file automatically generated from MApp.Endpoints.AppContentController
 */ 

import { MetadataClient } from '../metadataClient';
import { ISaveDesktopMApp, IMAppStatsListItem, ISaveBrowserMApp, ISaveMobileMApp, IMobileMApp, IMApp, IMAppListItem, IDesktopMApp, IBrowserMApp, IMAppStats, IValidationResult, IImage } from '../models';

export class AppContentClient extends MetadataClient {

    public static saveDesktopMApp(mApp: ISaveDesktopMApp) {
        return MetadataClient.ajax<IMAppStatsListItem>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/mapps/desktop`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(mApp)
			})
        );
    }

    public static saveBrowserMApp(mApp: ISaveBrowserMApp) {
        return MetadataClient.ajax<IMAppStatsListItem>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/mapps/browser`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(mApp)
			})
        );
    }

    public static saveMobileMApp(mApp: ISaveMobileMApp) {
        return MetadataClient.ajax<IMAppStatsListItem>(
            new Request(MetadataClient.endpointsUrl + `api/v3/studio/mapps/mobile`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(mApp)
			})
        );
    }

    public static updateMobileMApp(id: string, mApp: ISaveMobileMApp) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v3/studio/mapps/mobile/${encodeURIComponent(id)}`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'PUT',
				body: JSON.stringify(mApp)
			})
        );
    }

    public static getMobileMApp(id: string) {
        return MetadataClient.ajax<IMobileMApp>(
            new Request(MetadataClient.endpointsUrl + `api/v3/studio/mapps/mobile/${encodeURIComponent(id)}`)
        );
    }

    public static deleteMAppImagePreview(id: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/template/mapps/${encodeURIComponent(id)}/image`, {
				method: 'DELETE'
			})
        );
    }

    public static updateDesktopMApp(id: string, mApp: ISaveDesktopMApp) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/mapps/desktop/${encodeURIComponent(id)}`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'PUT',
				body: JSON.stringify(mApp)
			})
        );
    }

    public static updateBrowserMApp(id: string, mApp: ISaveBrowserMApp) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/mapps/browser/${encodeURIComponent(id)}`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'PUT',
				body: JSON.stringify(mApp)
			})
        );
    }

    public static deleteMApp(id: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/mapps/${encodeURIComponent(id)}`, {
				method: 'DELETE'
			})
        );
    }

    public static getMApps() {
        return MetadataClient.ajax<IMApp[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/mapps`)
        );
    }

    public static getMAppsByAppType(appType: number) {
        return MetadataClient.ajax<IMAppListItem[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/mapps/${appType}`)
        );
    }

    public static getDesktopMApp(id: string) {
        return MetadataClient.ajax<IDesktopMApp>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/mapps/desktop/${encodeURIComponent(id)}`)
        );
    }

    public static getBrowserMApp(id: string) {
        return MetadataClient.ajax<IBrowserMApp>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/mapps/browser/${encodeURIComponent(id)}`)
        );
    }

    public static getMAppListItems() {
        return MetadataClient.ajax<IMAppListItem[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/mapps/items`)
        );
    }

    public static getMAppStats() {
        return MetadataClient.ajax<IMAppStatsListItem[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/mapps/stats`)
        );
    }

    public static getMAppStatsById(id: string) {
        return MetadataClient.ajax<IMAppStats>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/mapps/${encodeURIComponent(id)}/stats`)
        );
    }

    public static isValidApp(name: string) {
        return MetadataClient.ajax<IValidationResult>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/mapps/isvalid?name=${encodeURIComponent(name)}`)
        );
    }

    public static deleteImage(fileName: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/images/${encodeURIComponent(fileName)}`, {
				method: 'DELETE'
			})
        );
    }

    public static getImages() {
        return MetadataClient.ajax<IImage[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/images`)
        );
    }
    
    public static saveMAppImagePreview(formData: FormData, id: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/mapps/${encodeURIComponent(id)}/image`, {
				headers: new Headers({ }),
				method: 'POST',
				body: formData,
				cache: 'no-cache'
			})
        );
    }
    
    public static saveImage(formData: FormData) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/images/upload`, {
				headers: new Headers({ }),
				method: 'POST',
				body: formData,
				cache: 'no-cache'
			})
        );
    }
}
